import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Radio,
  RadioGroup,
  FormControlLabel,
  Button,
  Typography,
  Box,
} from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  backgroundColor: "#000080", // Navy blue
  color: "white",
  textAlign: "center",
  padding: "16px 24px",
  fontWeight: "600",
  fontSize: "1.25rem",
}));

const StyledRadio = styled(Radio)(({ theme }) => ({
  color: "#000080",
  "&.Mui-checked": {
    color: "#000080",
  },
}));

const StyledButton = styled(Button)(({ theme }) => ({
  textTransform: "none",
  fontWeight: "600",
  padding: "8px 16px",
  borderRadius: "4px",
}));

export default function Registration({
  handleRegisterConfirm,
  registerPopupOpen,
  handleRegisterClose,
  handleUserTypeChange,
  userType,
}) {
  return (
    <Dialog
      open={registerPopupOpen}
      onClose={handleRegisterClose}
      PaperProps={{
        style: {
          borderRadius: "12px",
          overflow: "hidden",
        },
      }}
    >
      <StyledDialogTitle>Create Your Account</StyledDialogTitle>

      <DialogContent sx={{ padding: "28px" }}>
        <Typography
          variant="body1"
          sx={{
            marginBottom: "16px",
            marginTop: "10px",
            color: "#555",
            textAlign: "center",
          }}
        >
          Please select your account type to continue registration
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            padding: "0 16px",
          }}
        >
          <RadioGroup
            aria-label="user-type"
            name="user-type"
            value={userType}
            onChange={handleUserTypeChange}
          >
            <FormControlLabel
              value="candidate"
              control={<StyledRadio />}
              label={
                <Box sx={{ marginLeft: "8px" }}>
                  <Typography fontWeight="500">Candidate</Typography>
                  <Typography variant="caption" color="text.secondary">
                    Looking for a job?
                  </Typography>
                </Box>
              }
              sx={{
                padding: "12px 16px",
                borderRadius: "8px",
                border: "1px solid #eee",
                margin: "8px 0",
                alignItems: "start",
                "&:hover": {
                  backgroundColor: "#f5f5f5",
                },
              }}
            />

            <FormControlLabel
              value="client"
              control={<StyledRadio />}
              label={
                <Box sx={{ marginLeft: "8px" }}>
                  <Typography fontWeight="500">Client</Typography>
                  <Typography variant="caption" color="text.secondary">
                    Representing a company
                  </Typography>
                </Box>
              }
              sx={{
                padding: "12px 16px",
                borderRadius: "8px",
                border: "1px solid #eee",
                margin: "8px 0",
                alignItems: "start",
                "&:hover": {
                  backgroundColor: "#f5f5f5",
                },
              }}
            />
          </RadioGroup>
        </Box>
      </DialogContent>

      <DialogActions
        sx={{
          padding: "16px 24px",
          justifyContent: "end",
        }}
      >
        <StyledButton
          onClick={handleRegisterClose}
          sx={{
            color: "#000080",
            border: "1px solid #000080",
          }}
        >
          Cancel
        </StyledButton>
        <StyledButton
          onClick={handleRegisterConfirm}
          variant="contained"
          sx={{
            backgroundColor: "#000080",
            "&:hover": {
              backgroundColor: "#000080",
            },
          }}
        >
          Continue
        </StyledButton>
      </DialogActions>
    </Dialog>
  );
}
